import { Component, OnDestroy, AfterViewInit,
         EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { PermissionsService } from '../services/permissions.service';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';


@Component({
  selector: 'app-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EditorComponent),
      multi: true,
    }
  ]
})

export class EditorComponent implements AfterViewInit, OnDestroy, ControlValueAccessor {
  @Input() elementId: string;
  @Input() editorContent: string;
  @Input() placeholder: string;
  @Input() toolbar: string;
  @Output() onEditorKeyup: EventEmitter<string> = new EventEmitter<string>();

  private propagateChange: (_: any) => { };
  private propagateTouch: () => { };

  public editor;
  public setupComplete = false;
  public rawHtmlSwitchOn = false;
  public rawHtmlPermission = false;

  constructor(permissionsService: PermissionsService) {
    permissionsService.checkPermission('nomadicAdministration').subscribe(permissions => {
      this.rawHtmlPermission = permissions;
    });
  }

  public ngAfterViewInit(): void {
    // TODO: Figure out how to avoid having to do this!
    let base = document.querySelector('base');
    let skin_url = base.href + 'assets/skins/lightgray';
    setTimeout(() => {
      tinymce.init({
        selector: `#${this.elementId}`,
        plugins: ['link', 'paste', 'table', 'lists'],
        skin_url: skin_url,
        menubar: false,
        toolbar: this.toolbar || 'bold italic underline | undo redo | cut copy paste | link table',
        statusbar: false,
        min_height: 250,
        setup: editor => {
          this.editor = editor;
          editor.on('keyup change', () => {
            const content = editor.getContent();
            this.onEditorKeyup.emit(content);
            // Output values
            if (this.propagateChange) {
              this.propagateChange(content);
            }
            if (this.propagateTouch) {
              this.propagateTouch();
            }
          });
          this.setupComplete = true;
        },
      });
    }, 0);
  }

  public toggleEditorAndRaw() {
    this.rawHtmlSwitchOn = !this.rawHtmlSwitchOn;
    tinymce.execCommand('mceToggleEditor', false, this.elementId);
  }

  public ngOnDestroy() {
    tinymce.remove(this.editor);
  }

  public writeValue(text: string) {
    this.editorContent = text;
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched(fn: any) {
    this.propagateTouch = fn;
  }

  public setDisabledState(isDisabled: boolean) {
    
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/editor/editor.component.ts